import { render, staticRenderFns } from "./Door.vue?vue&type=template&id=0b8b095c&scoped=true&"
import script from "./Door.vue?vue&type=script&lang=js&"
export * from "./Door.vue?vue&type=script&lang=js&"
import style0 from "./Door.vue?vue&type=style&index=0&id=0b8b095c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8b095c",
  null
  
)

export default component.exports